module.exports = __webpack_public_path__ + "img/img26.9ecd5dce.svg";